import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const Auctions = ({ jitAuctions, aotAuctions, isMobile }) => {
    const { theme } = useTheme();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? '24px' : '34px' }}>
            <div style={{ textAlign: 'center', animation: 'bubbleAppear 1s ease-in-out' }}>
                <h2 style={{
                    color: theme.gold,
                    fontWeight: 'bolder',
                    textTransform: 'uppercase',
                    fontSize: isMobile ? '35px' : '51px',
                    margin: '0 0 10px 0'
                }}>
                    Active Auctions
                </h2>
                <p style={{
                    color: theme.accent,
                    fontWeight: 'bold',
                    fontSize: isMobile ? '20px' : '30px',
                    margin: '0'
                }}>
                    Bid for guaranteed slot inclusion
                </p>
            </div>

            {/* JIT Auctions */}
            <div style={{
                backgroundColor: theme.panelBg,
                borderRadius: '10px',
                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                animation: 'bubbleAppear 0.5s ease-in-out'
            }}>
                <div style={{
                    padding: isMobile ? '17px' : '26px',
                    borderBottom: `3px solid ${theme.accent}`,
                    textAlign: 'center'
                }}>
                    <h3 style={{
                        color: theme.gold,
                        fontWeight: 'bolder',
                        textTransform: 'uppercase',
                        margin: '0',
                        fontSize: isMobile ? '24px' : '32px'
                    }}>
                        JIT Auctions (Sealed-Bid)
                    </h3>
                </div>
                <div style={{ padding: isMobile ? '17px' : '26px' }}>
                    {jitAuctions.length === 0 ? (
                        <div style={{
                            textAlign: 'center',
                            color: theme.accent,
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            padding: isMobile ? '20px' : '30px',
                            fontSize: isMobile ? '18px' : '20px'
                        }}>
                            No active JIT auctions
                        </div>
                    ) : (
                        jitAuctions.map(auction => (
                            <div key={auction.slot_number} style={{
                                backgroundColor: theme.cardBg,
                                borderRadius: '5px',
                                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                                padding: isMobile ? '17px' : '20px',
                                marginBottom: isMobile ? '12px' : '17px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '12px'
                                }}>
                                    <div>
                                        <span style={{
                                            color: theme.text,
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            fontSize: isMobile ? '18px' : '22px'
                                        }}>
                                            Slot {auction.slot_number}
                                        </span>
                                        <div style={{
                                            color: theme.text,
                                            fontSize: isMobile ? '14px' : '16px',
                                            opacity: '0.8',
                                            marginTop: '4px'
                                        }}>
                                            Min Bid: {auction.min_bid} SOL
                                        </div>
                                    </div>
                                    {auction.current_winner && (
                                        <div style={{
                                            color: '#75bd4f',
                                            fontWeight: 'bold',
                                            fontSize: isMobile ? '14px' : '16px'
                                        }}>
                                            Winner: {auction.current_winner[0].slice(0, 8)}... ({auction.current_winner[1]} SOL)
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* AOT Auctions */}
            <div style={{
                backgroundColor: theme.panelBg,
                borderRadius: '10px',
                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                animation: 'bubbleAppear 0.6s ease-in-out'
            }}>
                <div style={{
                    padding: isMobile ? '17px' : '26px',
                    borderBottom: `3px solid ${theme.accent}`,
                    textAlign: 'center'
                }}>
                    <h3 style={{
                        color: theme.gold,
                        fontWeight: 'bolder',
                        textTransform: 'uppercase',
                        margin: '0',
                        fontSize: isMobile ? '24px' : '32px'
                    }}>
                        AOT Auctions (English-Style)
                    </h3>
                </div>
                <div style={{ padding: isMobile ? '17px' : '26px' }}>
                    {aotAuctions.length === 0 ? (
                        <div style={{
                            textAlign: 'center',
                            color: theme.accent,
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            padding: isMobile ? '20px' : '30px',
                            fontSize: isMobile ? '18px' : '20px'
                        }}>
                            No active AOT auctions
                        </div>
                    ) : (
                        aotAuctions.map(auction => (
                            <div key={auction.slot_number} style={{
                                backgroundColor: theme.accent,
                                borderRadius: '5px',
                                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                                padding: isMobile ? '17px' : '20px',
                                marginBottom: isMobile ? '12px' : '17px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '12px'
                                }}>
                                    <div>
                                        <span style={{
                                            color: theme.statusBarText,
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            fontSize: isMobile ? '18px' : '22px'
                                        }}>
                                            Slot {auction.slot_number}
                                        </span>
                                        <div style={{
                                            color: theme.statusBarText,
                                            fontSize: isMobile ? '14px' : '16px',
                                            opacity: '0.8',
                                            marginTop: '4px'
                                        }}>
                                            Min: {auction.min_bid} SOL | Bids: {auction.bids_count}
                                        </div>
                                    </div>
                                    <div>
                                        {auction.highest_bid && (
                                            <div style={{
                                                color: '#75bd4f',
                                                fontWeight: 'bold',
                                                fontSize: isMobile ? '14px' : '16px',
                                                marginBottom: '4px'
                                            }}>
                                                Highest: {auction.highest_bid} SOL
                                            </div>
                                        )}
                                        <div style={{
                                            color: theme.statusBarText,
                                            fontSize: isMobile ? '12px' : '14px',
                                            opacity: '0.7'
                                        }}>
                                            {auction.has_ended ? 'Ended' : 'Active'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default Auctions;
